<template>
  <div class="incomeStatistics">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="table">
        <span class="table-title">当前代理</span>
        <el-table :data="currentTableData" style="width: 100%" border>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column :prop="item.id" :label="item.name" v-for="item in currentTableNav"></el-table-column>
        </el-table>
      </div>
      <div class="table">
        <span class="table-title">下线代理</span>
        <el-table :data="nextTableData" style="width: 100%" border>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column :prop="item.id" :label="item.name" v-for="item in nextTableNav"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'incomeStatistics',
    data() {
      return {
        form: {
          agent: '',
          agentData: [],
          startTime: new Date(),
          endTime: new Date()
        },
        currentTableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '开始时间', id: 'startTime' },
          { name: '结束时间', id: 'endTime' },
          { name: '交易总奖励', id: 'assignTradeAmount' },
          { name: '实际交易奖励', id: 'assignLevelAmount' }
        ],
        currentTableData: [],
        nextTableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '开始时间', id: 'startTime' },
          { name: '结束时间', id: 'endTime' },
          { name: '交易总奖励', id: 'assignTradeAmount' },
          { name: '实际交易奖励', id: 'assignLevelAmount' }
        ],
        nextTableData: []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .incomeStatistics {
    margin: 20px;
    .table{
      margin-bottom: 30px;
      .table-title{
        overflow: hidden;
        display: block;
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: bolder;
      }
    }
  }
</style>
